import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { PageSparkles } from '@wix/wix-ui-icons-common';
import React, { useState, useEffect } from 'react';
import { ChevronDownSmall } from 'wix-ui-icons-common';

import css from './index.module.scss';

interface ArticleSummaryProps {
  summary: string;
}

export const ArticleSummary: React.FC<ArticleSummaryProps> = ({ summary }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);
  const [displayedText, setDisplayedText] = useState('');
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    if (summary && isTyping) {
      let currentIndex = 0;
      const typingInterval = setInterval(() => {
        if (currentIndex < summary.length) {
          setDisplayedText(summary.slice(0, currentIndex + 1));
          currentIndex++;
        } else {
          setIsTyping(false);
          clearInterval(typingInterval);
        }
      }, 30);

      return () => clearInterval(typingInterval);
    }
  }, [summary, isTyping]);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div onClick={toggleExpanded}>
      <Box className={css.wrapper} direction="vertical">
        <Box className={css.titleContainer} verticalAlign="middle">
          <PageSparkles />
          <Text size="small" className={css.title}>
            {t('article-page.copilot.summary.title')}
          </Text>
        </Box>
        <Box
          className={`${css.summaryContainer} ${isExpanded ? css.expanded : ''}`}
        >
          <Text size="small">
            {isTyping ? displayedText : summary}
          </Text>
        </Box>
        {!isExpanded && <Box className={css.expandButton} align="center">
          <ChevronDownSmall />
        </Box>}
      </Box>
    </div>
  );
};
